import React from 'react';
import styles from './RegisterSuccess.module.css';
import {Link} from "react-router-dom"

import Arrow from './Arrow.js';

export const RegisterSuccess = () => {
  return (
    <div className={styles.mainContainer}>
        <div className={styles.contentContainer}>
          <h1 style={{fontSize: "24px", textAlign: "center", marginTop: "20px", marginBottom: "50px", color: "#FFFFFF"}}>
            Thanks for joining GameWagrs!
          </h1>
          <p style={{marginBottom: "60px", textAlign: "center", fontFamily: 'Poppins'}}>
            You're officially on the platform - now it's time to activate your account.<br />
            <b>We've sent a confirmation email to verify your email address.</b>
          </p>
          <Link to = "/login">
            <button className={styles.loginButton}>
              Login
            </button>
          </Link>
          <p style={{ 
              maxWidth: "100%", 
              wordWrap: "break-word", 
              overflowWrap: "break-word",
              hyphens: "auto",
              textAlign: "center",
              marginBottom: "70px",
              fontFamily: 'Poppins'
          }}>
            Once you click that link, you'll gain access to your account to start<br />
            depositing funds, link your game accounts, and <b>make your first<br />Solo Showdown or 1v1 challenge!</b>
          </p>
          <span style={{ 
              whiteSpace: "nowrap", 
              color: "#8692A6", 
              fontWeight: "500", 
              textAlign: "center", 
              marginTop: "20px", 
              marginBottom: "0",
              fontSize: "16px",
          }}>
              <span style={{ color: "#66FF66" }}>Account Created</span>
              <span style={{ margin: "0 15px" }}>
                  <Arrow color='#757575' width={3} size={24} />
              </span> 
              Link Overwolf
              <span style={{ margin: "0 15px" }}>
                  <Arrow color='#757575' width={3} size={24} />
              </span> 
              Download Validator
              <span style={{ margin: "0 15px" }}>
                  <Arrow color='#757575' width={3} size={24} />
              </span> 
              Deposit Funds
          </span>
        </div>
    </div>
  )
}

// export default RegisterSuccess;
